export default __webpack_public_path__ + "2713aa275dc1274142a686d2430be4c5.png";